import { Button, Col, Row, StyleCard, VoiceVibeCard } from '@components';
import styles from './selectStoryOption.module.scss';
import { useRef, useState } from 'react';
import NarrativeCard from 'src/components/NarrativeCard';
import { IWhatIfStory, IWhatIfTopic } from 'src/core/repo/whatif/types';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSubmitWhatIfStory } from 'src/core/repo/whatif/useCase';
import { GoChevronLeft } from 'react-icons/go';
import { MdOutlineChevronLeft, MdOutlineChevronRight } from 'react-icons/md';

interface Props {
  selectedStory: IWhatIfStory | null;
  userStoryText: string;
  setStep: (step: number) => void;
  selectedTopic?: IWhatIfTopic;
}

const SelectStoryOptions = ({
  selectedStory,
  userStoryText,
  setStep,
  selectedTopic,
}: Props) => {
  const [selectedStyle, setSelectedStyle] = useState<string>('Cartoon');
  const [selectedNarrative, setSelectedNarrative] = useState<string>('alloy');
  const [selectedVibe, setSelectedVibe] = useState<string>('Auto');
  const [searchParams, setSearchParams] = useSearchParams();
  const language = searchParams.get('lang');
  const navigate = useNavigate();
  const styleSwiperRef = useRef<any>(null);
  const narrativeSwiperRef = useRef<any>(null);
  const voiceVibeSwiperRef = useRef<any>(null);

  const { mutateAsync, isLoading } = useSubmitWhatIfStory();

  const handleSubmit = () => {
    const data = {
      story_id: Number(selectedStory?.StoryID),
      story_desc: userStoryText,
      child_id: 6,
      whatif: selectedStory?.StoryWhatIf || '',
      image_style: selectedStyle,
      language: language || 'English',
      voice_speaker: selectedNarrative,
      voice_vibe: selectedVibe,
      age_range: selectedStory?.AgeRangeTitle || '',
      child_voice: '0',
      topic: selectedTopic?.Title || '',
      story_text: selectedStory?.StoryText || '',
    };

    mutateAsync(data, {
      onSuccess: (data) => {
        if (data) {
          navigate(`/dashboard/whatif-story/${data.response_story_id}`);
        }
      },
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.actions}>
        <button  onClick={() => setStep(5)} className={styles.back_button }>
          <GoChevronLeft size={22} />
          <p>Back</p>
        </button>
        <Button
          disabled={isLoading}
          onClick={handleSubmit}
          className={styles.back_button }>
          {isLoading ? 'Generating' : 'submit'}
        </Button>
      </div>

      <div className={styles.items_wrapper}>
        <div
          className={styles.sliderTitle}
          style={{ margin: '20px 0 0px 20px' }}>
          <h3 className="main-title text-purple">Choose Style Image</h3>
          <div className={styles.slider_button_wrapper}>
            <button
              className={styles.slider_button}
              type="button"
              onClick={() => styleSwiperRef.current?.slidePrev()}>
              <MdOutlineChevronLeft />
            </button>
            <button
              className={styles.slider_button}
              type="button"
              onClick={() => styleSwiperRef.current?.slideNext()}>
              <MdOutlineChevronRight />
            </button>
          </div>
        </div>
        <StyleCard
          ref={styleSwiperRef}
          selectedStyle={selectedStyle}
          setSelectedStyle={setSelectedStyle}
        />
      </div>

      <div>
        <div
          className={styles.sliderTitle}
          style={{ margin: '20px 0 0px 20px' }}>
          <h3 className="main-title text-purple">Story Narrative</h3>
          <div className={styles.slider_button_wrapper}>
            <button
              className={styles.slider_button}
              type="button"
              onClick={() => narrativeSwiperRef.current?.slidePrev()}>
              <MdOutlineChevronLeft />
            </button>
            <button
              className={styles.slider_button}
              type="button"
              onClick={() => narrativeSwiperRef.current?.slideNext()}>
              <MdOutlineChevronRight />
            </button>
          </div>
        </div>

        <Row gutter={40}>
          <Col xs={24}>
            <NarrativeCard
              ref={narrativeSwiperRef}
              narrative={selectedNarrative}
              setNarrative={setSelectedNarrative}
            />
          </Col>
        </Row>

        <div
          className={styles.sliderTitle}
          style={{ margin: '20px 0 0px 20px' }}>
          <h3 className="main-title text-purple">Emotional Tone</h3>
          <div className={styles.slider_button_wrapper}>
            <button
              className={styles.slider_button}
              type="button"
              onClick={() => voiceVibeSwiperRef.current?.slidePrev()}>
              <MdOutlineChevronLeft />
            </button>
            <button
              className={styles.slider_button}
              type="button"
              onClick={() => voiceVibeSwiperRef.current?.slideNext()}>
              <MdOutlineChevronRight />
            </button>
          </div>
        </div>

        <Row gutter={40}>
          <Col xs={24}>
            <VoiceVibeCard
              ref={voiceVibeSwiperRef}
              selectedNarrative={selectedNarrative}
              selectedVibe={selectedVibe}
              setSelectedVibe={setSelectedVibe}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SelectStoryOptions;
